import { ApolloClient, InMemoryCache, ApolloLink } from '@apollo/client/core'
import { onError } from '@apollo/client/link/error'
import { setContext } from '@apollo/client/link/context'
import VueApollo from 'vue-apollo'
import { getFingerprint } from '../services/fingerprint'
import { removeTokens } from '../helpers/removeTokens'
import { createUploadLink } from 'apollo-upload-client'

function getAuth() {
  let token
  if (typeof window !== 'undefined') token = window.localStorage.getItem('session_id')
  return token ? 'Bearer '.concat(token) : ''
}

const httpLinkWithUpload = createUploadLink({
  uri: process.env.VUE_APP_GRAPHQL_HTTP
})

const authLink = setContext((req, { headers = {} } = {}) => {
  const sessionId = getAuth()
  return {
    headers: {
      ...(sessionId ? { Authorization: sessionId } : {}),
      ...headers
    }
  }
})

let fingerprint
const fingerprintLink = setContext(async (req, { headers = {} } = {}) => {
  if (!fingerprint) {
    const { visitorId } = await getFingerprint()
    fingerprint = visitorId
  }

  return {
    headers: {
      fingerprint,
      ...headers
    }
  }
})

const logMessageLink = setContext((operation, { headers = {} } = {}) => {
  const operationDef = operation.query.definitions[0].operation
  const logMessage = localStorage.getItem('log_message')

  if (operationDef === 'mutation' && logMessage) {
    window.localStorage.removeItem('log_message')

    return {
      headers: {
        'log-message': logMessage.replaceAll('\n', ' '),
        ...headers
      }
    }
  }
})

const errorHandlerLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors)
    graphQLErrors.map(({ message, locations, path, extensions }) => {
      // console.log(`[GraphQL Error] Message: ${message}, Location: ${JSON.stringify(locations)}, Path: ${path}, Code: ${extensions.exception.code}`)
      if (message === 'missing.session' || message === 'session.expired' || message === 'authentication.missing.session.id' || message === 'invalid.session') {
        removeTokens()
        window.location.replace('/#/expired-session')
      }

      if (message === 'authentication.role.not.allowed') {
        window.location.replace('/#/not-authorized')
      }
    })
  if (networkError && networkError.statusCode === 401) window.location.replace('/#/expired-session')
  if (networkError) console.log(`[Network Error] ${networkError.message}`)
})

const apolloClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: ApolloLink.from([errorHandlerLink, logMessageLink, fingerprintLink, authLink, httpLinkWithUpload])
})

const apolloProvider = new VueApollo({
  defaultClient: apolloClient
})

export default apolloProvider
